export default __webpack_public_path__ + "static/media/envelope-solid.db1e6318.svg";